function hydrateImageLightbox(component) {
  const image = component.querySelector('[data-bmp-lightbox-image]');
  if (!(image instanceof HTMLImageElement) || image.dataset.bmpHydrated === 'true') return;

  const srcset = image.dataset.srcset;
  const src = image.dataset.src;

  if (srcset) {
    image.srcset = srcset;
    image.sizes = '100vw';
  }

  if (src) image.src = src;

  image.dataset.bmpHydrated = 'true';
}

function initImageLightboxes(root = document) {
  for (const component of root.querySelectorAll('[data-bmp-image-lightbox]')) {
    if (!(component instanceof HTMLElement) || component.dataset.bmpLightboxReady === 'true') continue;

    component.dataset.bmpLightboxReady = 'true';
    component.addEventListener(
      'dialog:open',
      () => hydrateImageLightbox(component),
      { once: true }
    );
  }
}

initImageLightboxes();

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target;
  if (section instanceof Element) initImageLightboxes(section);
});
